/**
 * SAGIA brand logo (wordmark) as an inline SVG component.
 * Paths from Figma Foundations → Logos page.
 */

import React from 'react';

interface SaqiaLogoProps {
  width?: number;
  height?: number;
  color?: string;
}

const SaqiaLogo: React.FC<SaqiaLogoProps> = ({
  width,
  height = 32,
  color = '#fff',
}) => {
  // Native aspect ratio from Figma: 101.611 / 32 ≈ 3.175
  const w = width ?? height * (101.611 / 32);

  return (
    <svg
      width={w}
      height={height}
      viewBox="0 0 101.611 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Sagia"
    >
      {/* s */}
      <path
        transform="translate(0, 3.728)"
        d="M11.2868 8.82809L8.16416 8.21523C7.33972 8.05472 6.74875 7.82125 6.37665 7.51482C6.00456 7.21569 5.82216 6.81441 5.82216 6.32558C5.82216 5.72731 6.07752 5.23849 6.58094 4.86639C7.08436 4.4943 7.74829 4.3119 8.57273 4.3119C9.39717 4.3119 10.1632 4.52348 10.7907 4.94665C11.4181 5.36981 11.8194 5.96808 11.9799 6.73415H17.1528C17.1236 5.45007 16.7588 4.29731 16.0438 3.28317C15.3288 2.26904 14.3438 1.47378 13.067 0.882809C11.7975 0.291838 10.3238 0 8.65299 0C6.21614 0 4.24624 0.590971 2.74327 1.76562C1.24031 2.94026 0.488828 4.487 0.488828 6.40584C0.488828 8.10579 0.984952 9.42636 1.9699 10.3894C2.95486 11.3452 4.53078 12.0164 6.69038 12.4031L9.72549 12.9357C10.6521 13.1254 11.3233 13.3808 11.7392 13.6945C12.1477 14.0082 12.352 14.4387 12.352 14.9859C12.352 15.5914 12.0456 16.0803 11.4254 16.4669C10.8126 16.8536 10.0246 17.0433 9.06156 17.0433C8.09849 17.0433 7.23757 16.839 6.53716 16.4305C5.83675 16.0219 5.40629 15.4163 5.24578 14.6211H0C0.138623 16.7296 0.97036 18.3785 2.50251 19.5677C4.03466 20.757 6.17237 21.3552 8.90834 21.3552C10.6594 21.3552 12.1988 21.0707 13.5267 20.5162C14.8545 19.9544 15.8833 19.1664 16.6056 18.1523C17.3279 17.1382 17.6927 15.9781 17.6927 14.6648C17.6927 13.0743 17.1892 11.8194 16.1751 10.8855C15.161 9.95166 13.534 9.27314 11.2868 8.83538V8.82809Z"
        fill={color}
      />
      {/* a */}
      <path
        transform="translate(19.835, 3.722)"
        d="M16.4159 3.29777C15.9343 2.62654 15.3653 2.03557 14.694 1.53944C13.4318 0.620155 11.834 0.109439 9.8933 0C7.97446 0 6.26721 0.445052 4.76425 1.33516C3.26129 2.22526 2.08664 3.48016 1.2549 5.09257C0.415868 6.70497 0 8.57273 0 10.674C0 12.7752 0.415868 14.643 1.2549 16.2554C2.08664 17.8678 3.26129 19.1227 4.76425 20.0128C6.26721 20.9029 7.98176 21.3479 9.8933 21.3479C11.8048 21.3479 13.4318 20.881 14.6794 19.9544C15.409 19.4072 16.0146 18.736 16.518 17.9626L16.7077 20.9394H21.7565V0.415869H16.4232V3.29777H16.4159ZM15.2412 15.0515C14.1833 16.1605 12.7971 16.715 11.0752 16.715C9.3534 16.715 7.95987 16.1605 6.90926 15.0515C5.85864 13.9425 5.32604 12.4834 5.32604 10.6813C5.32604 8.87916 5.85134 7.41997 6.90926 6.31099C7.95987 5.20201 9.3534 4.64752 11.0752 4.64752C12.7971 4.64752 14.1906 5.19471 15.2412 6.2891C16.2918 7.38349 16.8244 8.83539 16.8244 10.6448C16.8244 12.4542 16.2991 13.9498 15.2412 15.0588V15.0515Z"
        fill={color}
      />
      {/* g */}
      <path
        transform="translate(45.034, 3.728)"
        d="M16.8974 1.33516C15.212 0.445052 13.2786 0 11.0898 0C8.90105 0 6.96033 0.445052 5.28226 1.33516C3.5969 2.22526 2.29822 3.48016 1.37893 5.09257C0.459644 6.70497 0 8.57273 0 10.674C0 12.7752 0.459644 14.643 1.37893 16.2554C2.29822 17.8678 3.5969 19.1227 5.28226 20.0128C6.96762 20.9029 8.90105 21.3479 11.0898 21.3479C13.2786 21.3479 15.212 20.9029 16.8974 20.0128C18.5828 19.1227 19.8814 17.8751 20.7934 16.2554C21.7127 14.643 22.1724 12.7825 22.1724 10.674C22.1724 8.56544 21.7127 6.70497 20.7934 5.09257C19.8741 3.48016 18.5755 2.22526 16.8974 1.33516ZM15.2558 15.0442C14.1979 16.1532 12.8117 16.7077 11.0898 16.7077C9.36799 16.7077 7.97446 16.1532 6.92385 15.0442C5.87323 13.9352 5.34063 12.4761 5.34063 10.674C5.34063 8.87187 5.86594 7.41268 6.92385 6.30369C7.97446 5.19471 9.36799 4.64022 11.0898 4.64022C12.8117 4.64022 14.2052 5.18742 15.2558 6.28181C16.3064 7.3762 16.839 8.82809 16.839 10.6375C16.839 12.4469 16.3137 13.9425 15.2558 15.0515V15.0442Z"
        fill={color}
      />
      {/* i stem */}
      <path
        transform="translate(70.86, 4.138)"
        d="M5.34063 0H0V20.5308H5.34063V0Z"
        fill={color}
      />
      {/* swoosh tail */}
      <path
        transform="translate(49.77, 26.294)"
        d="M0 5.70543H8.82809C11.9799 5.70543 14.5335 3.15185 14.5335 0H5.70543C2.55358 0 0 2.55358 0 5.70543Z"
        fill={color}
      />
      {/* i dot */}
      <path
        transform="translate(62.02, -0.006)"
        d="M2.26904 4.53808C3.52394 4.53808 4.53808 3.52394 4.53808 2.26904C4.53808 1.01414 3.52394 0 2.26904 0C1.01414 0 0 1.01414 0 2.26904C0 3.52394 1.01414 4.53808 2.26904 4.53808Z"
        fill={color}
      />
      {/* a (second) */}
      <path
        transform="translate(79.856, 3.722)"
        d="M16.4159 0.415869V3.29777C15.9343 2.62654 15.3653 2.03557 14.694 1.53944C13.4318 0.620155 11.834 0.109439 9.8933 0C7.97447 0 6.26722 0.445052 4.76425 1.33516C3.26129 2.22526 2.08664 3.48016 1.2549 5.09257C0.41587 6.70497 0 8.57273 0 10.674C0 12.7752 0.41587 14.643 1.2549 16.2554C2.08664 17.8678 3.26129 19.1227 4.76425 20.0128C6.26722 20.9029 7.98176 21.3479 9.8933 21.3479C11.8048 21.3479 13.4318 20.881 14.6721 19.9544C15.4017 19.4072 16.0073 18.736 16.5107 17.9626L16.7004 20.9394H21.7492V0.415869H16.4159ZM15.2485 15.0515C14.1906 16.1605 12.8044 16.715 11.0825 16.715C9.3607 16.715 7.96717 16.1605 6.91656 15.0515C5.86594 13.9425 5.33334 12.4834 5.33334 10.6813C5.33334 8.87916 5.85864 7.41997 6.91656 6.31099C7.96717 5.20201 9.3607 4.64752 11.0825 4.64752C12.8044 4.64752 14.1979 5.19471 15.2485 6.2891C16.2991 7.38349 16.8317 8.83539 16.8317 10.6448C16.8317 12.4542 16.3064 13.9498 15.2485 15.0588V15.0515Z"
        fill={color}
      />
    </svg>
  );
};

export default SaqiaLogo;
